/**
 * Dashboard Alpine.js Entry Point
 * Integrates all Alpine components for Dashboard V5
 */

// Import the complete dashboard-v5-store (which already includes all components)
import './alpine/dashboard-v5-store.js';

// The dashboard-v5-store.js already handles:
// - Alpine store registration
// - All component registrations
// - HTMX integration
// - Global dashboard functions
// - Export functions

// This file just imports and re-exports everything for compatibility
console.log('[Dashboard Alpine] Entry point loaded');
